import { useTopLabel } from "../AppHooks";
import { IconArrow } from "../icon/master";
import { SingleImg } from "./SingleImg";

export function TopBack(props: { onClick: (e: React.MouseEvent) => void, children?: React.ReactNode }) {
    const topLabel = useTopLabel()
    return (
        <div className="top-back-content" onClick={props.onClick}>
            <IconArrow />
            {
                props.children ? props.children : <>
                    {
                        typeof topLabel.content === 'string' && <span>{topLabel.content}</span>
                    }
                    {
                        typeof topLabel.content !== 'string' && <SingleImg className="img" image={topLabel.content} />
                    }
                </>
            }

        </div>
    )
}
